import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-3 row justify-content-center"
}
const _hoisted_2 = {
  style: {"height":"400px","width":"100%"},
  class: "position-relative"
}
const _hoisted_3 = ["src"]

import Api from '@/services/api';
    import { Car, Event, TravelCompany } from '@/services/types';
    import { ElButton, ElMessage, ElRow, FormInstance, FormRules, ElCol, ElInput, ElFormItem } from 'element-plus';
    import { onBeforeMount, reactive, ref } from 'vue';
    import "leaflet/dist/leaflet.css";
    import { LMap, LTileLayer, LMarker, LTooltip} from "@vue-leaflet/vue-leaflet"
    import PersonalTable from '@/components/PersonalTable.vue';
import { useRouter } from 'vue-router';


    
export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyInfoView',
  setup(__props) {

    const loading = ref<boolean>(true)
    const formRef = ref<FormInstance>()
    const apiImage = ref<string>()
    const cars = ref<Array<Car>>([])
    const error = ref<boolean>(false)
    const router = useRouter()

    const travels = () => router.push('/companies-dashboard/travel')
    
    const company = reactive<TravelCompany>({
        description: '',
        image: null,
        name: '',
        area: {lat: 0, long: 0, name: ''},
        id: 0,
        user: undefined,
        segments: [],
        phone: null,
        password: null
    })

    const getImageUrl = (image: string) => `${Api.publicUrl}alt-storage?path=travel_companies/${image}`

    const rules = ref<FormRules<Event>>({
        name: [{required: true, message: 'Preencha este campo'}],
        description: [{required: true, message: 'Preencha este campo'}],
        "area.name": [{required: true, message: 'Preencha este campo'}],
    })

    const password = sessionStorage.getItem('password')
    const phone = sessionStorage.getItem('phone')

    const getCompany = async () => {
        const res = await Api.get(`companies?phone=${phone}&password=${password}`)

        if (res.status == 200) {
            const data = res.data.company
    
            company.id = data.id
            company.area = data.area
            company.user = data.user
            company.name = data.name
            company.phone = data.phone
            company.description = data.description
            company.created_at = data.created_at
            company.segments = data.trip_segments
            cars.value = data.cars

            apiImage.value = getImageUrl(data.image)
            company.image = apiImage.value
            error.value = false
            console.log(data)
        } else {
            console.log(res)
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
            error.value = true
        }
    }

    onBeforeMount(async () => {
        loading.value = true
        await Promise.all([
            getCompany(),
        ])
        loading.value = false
    })

return (_ctx: any,_cache: any) => {
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_card = _resolveComponent("el-card")!

  return (!error.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_card, {
          class: "col-12",
          header: company.id ? company.name:'Procurando Empresa'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_skeleton, {
              loading: loading.value,
              animated: "",
              rows: 12
            }, {
              default: _withCtx(() => [
                company
                  ? (_openBlock(), _createBlock(_component_el_form, {
                      key: 0,
                      disabled: "",
                      model: company,
                      "label-position": "top",
                      rules: rules.value,
                      ref_key: "formRef",
                      ref: formRef
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ElRow), { gutter: 30 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElCol), {
                              sm: 24,
                              md: 12,
                              lg: 10
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElFormItem), {
                                  label: "Nome da empresa",
                                  prop: "name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ElInput), {
                                      name: "name",
                                      modelValue: company.name,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((company.name) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(ElFormItem), {
                                  label: "Descricao da empresa",
                                  prop: "description"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ElInput), {
                                      type: "textarea",
                                      name: "description",
                                      modelValue: company.description,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((company.description) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(ElFormItem), { label: "Cadastrado" }, {
                                  default: _withCtx(() => [
                                    _cache[3] || (_cache[3] = _createTextVNode(" Por ", -1)),
                                    _createElementVNode("b", null, _toDisplayString(company.user?.name), 1),
                                    _cache[4] || (_cache[4] = _createTextVNode(", em ", -1)),
                                    _createElementVNode("b", null, _toDisplayString(company.created_at ? new Date(company.created_at).toLocaleString():'-'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(ElCol), {
                              sm: 24,
                              md: 12,
                              lg: 14
                            }, {
                              default: _withCtx(() => [
                                (company.area)
                                  ? (_openBlock(), _createBlock(_unref(ElFormItem), {
                                      key: 0,
                                      label: "Local",
                                      prop: "area.name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(ElInput), {
                                          name: "area",
                                          modelValue: company.area.name,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((company.area.name) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_2, [
                                  (company.area)
                                    ? (_openBlock(), _createBlock(_unref(LMap), {
                                        key: 0,
                                        ref: "map",
                                        zoom: 16,
                                        center: [company.area.lat, company.area.long]
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(LTileLayer), {
                                            url: "http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga",
                                            "layer-type": "base",
                                            name: "OpenStreetMap"
                                          }),
                                          (company.area)
                                            ? (_openBlock(), _createBlock(_unref(LMarker), {
                                                key: 0,
                                                "lat-lng": [company.area.lat, company.area.long]
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(LTooltip), null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(company.name), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 8, ["lat-lng"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      }, 8, ["center"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createVNode(_unref(ElFormItem), {
                                  label: "Logotipo",
                                  prop: "image"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("img", {
                                      style: {"max-height":"250px","max-width":"100%"},
                                      src: (company.image as string)
                                    }, null, 8, _hoisted_3)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "rules"]))
                  : _createCommentVNode("", true),
                _createVNode(_unref(ElButton), {
                  type: "primary",
                  "native-type": "button",
                  onClick: travels
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("Ver viagens", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(ElRow), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElCol), {
                      sx: 24,
                      md: 12,
                      class: "p-4"
                    }, {
                      default: _withCtx(() => [
                        _cache[6] || (_cache[6] = _createElementVNode("h4", null, "Carros", -1)),
                        _createVNode(PersonalTable, {
                          loading: loading.value,
                          height: 450,
                          showRows: 10,
                          cols: [
                                {label: '#', prop: 'id'},
                                {label: 'Referencia', prop: 'reference'},
                                {label: 'Nome', prop: 'name'},
                                {label: 'Placa', prop: 'plate'},
                            ],
                          data: cars.value
                        }, null, 8, ["loading", "data"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(ElCol), {
                      sx: 24,
                      md: 12,
                      class: "p-4"
                    }, {
                      default: _withCtx(() => [
                        _cache[7] || (_cache[7] = _createElementVNode("h4", null, "Preços", -1)),
                        _createVNode(PersonalTable, {
                          loading: loading.value,
                          height: 450,
                          showRows: 10,
                          cols: [
                                {label: '#', prop: 'id'},
                            ],
                          data: company.segments
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              label: "Trecho",
                              "class-name": "auto",
                              "min-width": 150
                            }, {
                              default: _withCtx((data) => [
                                _createTextVNode(_toDisplayString(data.row.from.name) + " - " + _toDisplayString(data.row.to.name), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Preço",
                              "class-name": "auto",
                              "min-width": 150
                            }, {
                              default: _withCtx((data) => [
                                _createTextVNode(_toDisplayString(data.row.pivot.price) + " MT ", 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["loading", "data"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        }, 8, ["header"])
      ]))
    : _createCommentVNode("", true)
}
}

})